'use strict';

angular.module('youth').directive('msThriveOverlay', [function () {
  return {
    templateUrl: 'youth/templates/thrive-overlay.html',
    restrict: 'E',
    bindToController: true,
    controller: 'ThriveOverlayCtrl',
    controllerAs: 'vm'
  };
}]).controller('ThriveOverlayCtrl', ['eventTrackingSvc', '$scope', function (eventTrackingSvc, $scope) {
  var vm = this;
  vm.thrive = $scope.dataModel.thrive;
  //acknowledge it's been seen - calling back to the parent launching scope
  $scope.callback();
}]);